var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "106px",
        height: "106px",
        viewBox: "0 0 106 106",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs", [
        _c("polygon", {
          attrs: { id: "path-1", points: "0 0 39.7924528 0 39.7924528 57 0 57" }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-HD",
                transform: "translate(-1215.000000, -413.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group",
                    transform: "translate(1215.000000, 413.000000)"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M106,90.9548646 C106,99.2637914 99.2146745,106 90.8451633,106 L15.1548367,106 C6.78532554,106 0,99.2637914 0,90.9548646 L0,15.0451354 C0,6.73520562 6.78532554,0 15.1548367,0 L90.8451633,0 C99.2146745,0 106,6.73520562 106,15.0451354 L106,90.9548646 Z",
                      id: "Mask",
                      fill: "#DB93C8"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group-3",
                        transform: "translate(33.000000, 25.000000)"
                      }
                    },
                    [
                      _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                        _c("use", { attrs: { "xlink:href": "#path-1" } })
                      ]),
                      _vm._v(" "),
                      _c("g", { attrs: { id: "Clip-2" } }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M33.0051829,33.9867471 C32.0368597,33.9867471 31.2475638,33.1656411 31.2475638,32.1568539 C31.2475638,31.1492396 32.0368597,30.3257877 33.0051829,30.3257877 C33.9735061,30.3257877 34.7628021,31.1492396 34.7628021,32.1568539 C34.7628021,33.1656411 33.9735061,33.9867471 33.0051829,33.9867471 M21.2141593,51.7589982 C20.2447102,51.7589982 19.4565401,50.9378923 19.4565401,49.927932 C19.4565401,48.9203177 20.2447102,48.0968658 21.2141593,48.0968658 C22.1824825,48.0968658 22.9706525,48.9203177 22.9706525,49.927932 C22.9706525,50.9378923 22.1824825,51.7589982 21.2141593,51.7589982 M6.78839586,28.5005865 C5.81894673,28.5005865 5.03190265,27.6794806 5.03190265,26.6695203 C5.03190265,25.660733 5.81894673,24.8384541 6.78839586,24.8384541 C7.757845,24.8384541 8.54714098,25.660733 8.54714098,26.6695203 C8.54714098,27.6794806 7.757845,28.5005865 6.78839586,28.5005865 M15.1925403,5.23982878 C16.1631154,5.23982878 16.9512854,6.06210771 16.9512854,7.07206799 C16.9512854,8.08202828 16.1631154,8.90196119 15.1925403,8.90196119 C14.2242171,8.90196119 13.4360471,8.08202828 13.4360471,7.07206799 C13.4360471,6.06210771 14.2242171,5.23982878 15.1925403,5.23982878 M33.0051829,25.0847859 C30.7814175,25.0847859 28.6848852,26.2401992 27.428317,28.1299158 L13.4214096,25.1786266 C13.1703212,23.9481407 12.6017128,22.8044574 11.7842679,21.8848188 L14.9313182,14.139444 C15.016891,14.14179 15.1058416,14.144136 15.1936662,14.144136 C18.9363479,14.144136 21.9820621,10.9723211 21.9820621,7.073241 C21.9820621,3.17298788 18.9363479,0 15.1936662,0 C11.4498586,0 8.40527038,3.17298788 8.40527038,7.073241 C8.40527038,8.83861873 9.01553917,10.4937337 10.1313627,11.781697 L6.9584154,19.6021443 C3.15718394,19.5282448 0.00112595718,22.7188278 0,26.6706933 C0,30.5697734 3.04571418,33.7415883 6.78839586,33.7415883 C9.05832554,33.7415883 11.1818808,32.5498117 12.4350711,30.6002716 L26.3440202,33.5257547 C26.5219215,34.4817566 26.8878575,35.3826271 27.4159315,36.1744078 L23.1643171,43.1549812 C22.5292773,42.9567427 21.8750962,42.855864 21.2141593,42.855864 C17.4714776,42.855864 14.4257634,46.0288519 14.4257634,49.929105 C14.4257634,53.8281851 17.4714776,57 21.2141593,57 C24.956841,57 28.0014292,53.8281851 28.0014292,49.929105 C28.0014292,48.8030169 27.7469629,47.701562 27.2628013,46.7197539 L31.8938632,39.1327352 C32.2609252,39.1972506 32.6324911,39.2289219 33.0051829,39.2289219 C36.7478646,39.2289219 39.7924528,36.055934 39.7924528,32.1568539 C39.7924528,28.2577738 36.7478646,25.0847859 33.0051829,25.0847859",
                          id: "Fill-1",
                          fill: "#FFFFFF",
                          mask: "url(#mask-2)"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }